import React from "react";

const Layout = ({ children, className = "" }) => {
  const hasCustomBg = /\bbg-\[|\bbg-\w/.test(className);
  return (
    <div
      className={`font-sans min-h-screen ${
        hasCustomBg ? "" : "bg-[#F6F0EB]"
      } ${className}`.trim()}
    >
      <div className="w-full min-h-screen max-w-[650px] m-auto">
        {children}
      </div>
    </div>
  );
};

export default Layout;
